/**
 * StaffPortalAnnouncementService
 * Read-only feed of Published announcements for the staff portal.
 * Route: api/staff-portal/announcements
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
export class StaffPortalAnnouncementService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalAnnouncementService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalAnnouncementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Returns the active staff feed: Published rows that haven't expired. */
    async listActive(take = 10) {
        return (await this.listActiveRaw(take)).data ?? [];
    }
    listActiveRaw(take = 10) {
        return this.get(`?take=${take}`);
    }
    async getById(id) {
        return (await this.getByIdRaw(id)).data ?? null;
    }
    getByIdRaw(id) {
        return this.get(`${id}`);
    }
}
StaffPortalAnnouncementService.DEFAULT_SERVICE_PATH = 'hr';
StaffPortalAnnouncementService.BASE_PATH = 'api/staff-portal/announcements';
//# sourceMappingURL=StaffPortalAnnouncementService.js.map